import * as pageActions from './page/actions';
import * as reportActions from './report/actions';

export const actions = {
  ...pageActions,
  ...reportActions,
};



// WEBPACK FOOTER //
// ./src/pages/prohibiteditems/state/actions.js